import styled from 'styled-components';

export const PageWrapper = styled.div`
  height: 100vh;
  height: 100dvh;
  padding-top: env(safe-area-inset-top);
  padding-bottom: env(safe-area-inset-bottom);
  display: grid;
  grid-template-rows: auto 1fr auto;
  grid-template-areas: 'header' 'main' 'footer';
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;

  @media (screen-spanning: single-fold-vertical) {
    width: env(fold-left);
  }

  @media (horizontal-viewport-segments: 2) {
    width: env(viewport-segment-right 0 0);
  }
`;

export const FormWrapper = styled.div`
  width: 400px;
  max-width: 100vw;
  padding: var(--gap);
  margin: auto;

  form {
    margin: var(--gap) 0;
  }
`;

export const Main = styled.main`
  text-align: center;

  @media screen and (min-width: 769px) {
    text-align: left;
  }
`;
